import { render } from "./InstanceTableMob.vue?vue&type=template&id=11c64f7e&scoped=true&ts=true"
import script from "./InstanceTableMob.vue?vue&type=script&lang=ts"
export * from "./InstanceTableMob.vue?vue&type=script&lang=ts"

import "./InstanceTableMob.vue?vue&type=style&index=0&id=11c64f7e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11c64f7e"]])

export default __exports__